import axios from 'axios';

export const launchDigitex = async (token, { returnToSite = false } = {}) => {
  if (!token) {
    throw new Error('Sessione Filmar non disponibile.');
  }

  const response = await axios.post('/v1/digitex/launch', { return_to_site: returnToSite }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const handoffUrl = response?.data?.handoff_url;

  if (!handoffUrl) {
    throw new Error('Risposta SSO Digitex non valida.');
  }

  window.location.assign(handoffUrl);
};

export const logoutDigitex = async () => {
  const token = localStorage.getItem('token');
  try {
    if (token) {
      await axios.post('/v1/logout', {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  } catch {
    // Clear the browser session even if the site token has expired.
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('userDataDetail');
    localStorage.removeItem('agentDataDetail');
    window.location.assign(`${process.env.REACT_APP_DIGITEX_APP_URL || 'https://digitex.filmar.it'}/logout`);
  }
};
